import React, { useContext, useEffect, useReducer } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'model';
import { setScheduleSelectedDate } from 'model/meeting';
import { CurrentMode } from '../types/type';
import moment, { Moment } from 'moment';

type QuerysProviderProps = {
  initState?: any;
};
interface IOriginState {
  currentTime: number;
  currentMode: CurrentMode;
  calendarMonth: Moment;
  isFirstBlink: boolean;
  isScheduleDateSelected: boolean;
}

interface IContext {
  originState: IOriginState;
  scheduleDispatch: React.Dispatch<AnyAction>;
}

/*
 actionTppe
*/
interface AnyAction {
  type: 'SET_STATE';
  payload: { [key: string]: any };
}

/*
 reducer
*/
function modelReducer(state: IOriginState, action: AnyAction) {
  switch (action.type) {
    case 'SET_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

const createOriginState = (selectedDate: number | null = null): IOriginState => {
  const date = selectedDate === null ? moment().startOf('day') : moment(selectedDate);
  return {
    currentTime: date.valueOf(),
    currentMode: CurrentMode.schedule,
    calendarMonth: date.clone(),
    isFirstBlink: true,
    isScheduleDateSelected: selectedDate !== null
  };
};

const originState = createOriginState();

const defaultContent = {
  originState,
  scheduleDispatch: () => {}
};

const ScheduleContext = React.createContext<IContext>(defaultContent);

export function useScheduleContext() {
  return useContext(ScheduleContext);
}

const ScheduleProvider: React.FC<QuerysProviderProps> = (props) => {
  const { children } = props;
  const dispatch = useDispatch();
  const selectedDate = useSelector((state: RootState) => state.meeting.scheduleSelectedDate);
  const [state, scheduleDispatch] = useReducer(modelReducer, selectedDate, createOriginState);

  useEffect(() => {
    dispatch(setScheduleSelectedDate(state.isScheduleDateSelected ? state.currentTime : null));
  }, [dispatch, state.currentTime, state.isScheduleDateSelected]);

  return <ScheduleContext.Provider value={{ originState: state, scheduleDispatch }}>{children}</ScheduleContext.Provider>;
};
export default ScheduleProvider;
